export const FirebaseRegions = {
  EU_WEST_2: 'europe-west2',
};
